<template>
  <div class="w_newslist">
    <div class="big_title">展商动态</div>
    <div class="newslist">
      <ul>
        <li class="item" v-for="(item,index) in list_news" :key="index">
          <router-link :to="{name:'newsdetail',params:{id:item.id}}" target="_blank">
            <div class="image">
              <img :src="utils.HandleUrl(item.img_url)" >
            </div>
            <div class="desc">
              <p class="title">{{item.title}}</p>
              <p class="zhaiyao">{{item.zhaiyao}}</p>
              <p class="time">发布时间：{{item.add_time_str2}}</p>
            </div>
          </router-link>
        </li>
      </ul>
    </div>

    <Pagination v-model="pageindex" :total="list_total" :pagesize="pagesize" :is_white="true" />
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import $ from 'jquery'
export default {
  data(){
    return {
      list_news:[],
      list_total:0,
      pageindex:1,
      pagesize:4
    }
  },
  created(){
    this.getNewsList();
  },
  components:{
    Pagination
  },
  methods:{
    getNewsList(){
      let url='https://m.xincailiao.com/service/newsApi.ashx?action=news_list_ByPage2';
      $.post(url,{pagesize: this.pagesize,pageindex: this.pageindex,apage_tags:'2019CMF展商动态'},(res)=>{
        let temp = JSON.parse(res);
        if(temp.status == 1){
          this.list_news = temp.ds;
          this.list_total = temp.total;
        }
      });
    }
  },
  watch:{
    pageindex(){
      this.getNewsList();
    }
  }
}
</script>